import angular from 'angular';
import uiRouter from 'angular-ui-router';

let adpDonutModule = angular.module('adpDonut', [
  uiRouter
])

.directive('donutChart', function() {
  function link(scope, element, attrs) {
    // generate donut chart
    var chart = c3.generate(scope.data);  
    element[0].append(chart.element);

    // set chart value and label text
    var label = d3.select(chart.element).select('text.c3-chart-arcs-title');
    label.insert('tspan').text(scope.text.value).attr('dy', 0).attr('x', 0).attr('class','chart-value');
    label.insert('tspan').text(scope.text.label).attr('dy', 25).attr('x', 0).attr('class','chart-label');
  }
  return {
    restrict: 'AE',
    scope: {
      data: '<',
      text: '<',
    },
    link: link,
  };
})

.name;

export default adpDonutModule;





// WEBPACK FOOTER //
// ./src/app/components/adpDonutChart/donutChart.js